export default __webpack_public_path__ + "static/media/Paynier.006461e5.jpg";